export default function setTopBar() {
  const topBar = document.querySelector('[data-top-bar]');
  if (!topBar) return;

  const buttonClose = topBar.querySelector('[data-close-topbar]');

  buttonClose.addEventListener('click', () => {
    topBar.remove();
  });
}
